module.exports = __webpack_public_path__ + "static/media/npr.org_2016_09_26_495115346_fact-check-first-presidential-debate_plot.cb818890.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/npr.org_2016_09_26_495115346_fact-check-first-presidential-debate_plot.png
// module id = 399
// module chunks = 0